module.exports = __webpack_public_path__ + "img/person-from-portal.52982fbd.svg";